import { normalizeClientDetailCategory } from "./clientDetailsCategory";

export const CLIENT_CATEGORY_STORAGE_KEY = "finlo_client_category_tab";
export const CLIENT_CATEGORY_CHANGE_EVENT = "finlo_client_category_change";

export function readStoredClientCategory() {
  try {
    return normalizeClientDetailCategory(
      sessionStorage.getItem(CLIENT_CATEGORY_STORAGE_KEY) || "individual",
    );
  } catch {
    return "individual";
  }
}

export function writeStoredClientCategory(category) {
  const next = normalizeClientDetailCategory(category);
  try {
    sessionStorage.setItem(CLIENT_CATEGORY_STORAGE_KEY, next);
  } catch {
    /* ignore quota errors */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(CLIENT_CATEGORY_CHANGE_EVENT, { detail: next }),
    );
  }
  return next;
}
